const getAuthorization = ()=>{
    if (localStorage.getItem('logged')=="true"){
        return {
            'Authorization': 'Bearer ' + localStorage.getItem('access')
        }
    }
    return {}
}

export default getAuthorization